/**
 * Template Data
 * Pre-designed website templates organized by category
 * Sources:
 * - Crafto HTML by ThemeZaa (https://craftohtml.themezaa.com/)
 * - Canvas Template (https://canvastemplate.com/)
 *
 * Note: Images are loaded from external sources. Fallback placeholders shown if images fail.
 */

const CRAFTO_BASE = 'https://craftohtml.themezaa.com'
const CANVAS_BASE = 'https://canvastemplate.com'

export const TEMPLATE_CATEGORIES = [
  'Professional Services',
  'Technology & SaaS',
  'Retail & Ecommerce',
  'Creative & Agency',
  'Food & Hospitality',
  'Healthcare & Wellness'
]

export const TEMPLATES = [
  // ========== Professional Services ==========
  {
    id: 'corporate',
    category: 'Professional Services',
    name: 'Corporate',
    description: 'Company, Business, Consulting',
    demoUrl: `${CRAFTO_BASE}/demo-corporate.html`,
    imageUrl: `${CRAFTO_BASE}/images/demo-corporate.jpg`,
    source: 'Crafto'
  },
  {
    id: 'business',
    category: 'Professional Services',
    name: 'Business',
    description: 'Company, Consulting, Corporate',
    demoUrl: `${CRAFTO_BASE}/demo-business.html`,
    imageUrl: `${CRAFTO_BASE}/images/demo-business.jpg`,
    source: 'Crafto'
  },
  {
    id: 'consulting',
    category: 'Professional Services',
    name: 'Consulting',
    description: 'Professional services, Startup',
    demoUrl: `${CRAFTO_BASE}/demo-consulting.html`,
    imageUrl: `${CRAFTO_BASE}/images/demo-consulting.jpg`,
    source: 'Crafto'
  },
  {
    id: 'lawyer',
    category: 'Professional Services',
    name: 'Lawyer',
    description: 'Law firm, Attorney, Legal, Advisor',
    demoUrl: `${CRAFTO_BASE}/demo-lawyer.html`,
    imageUrl: `${CRAFTO_BASE}/images/demo-lawyer.jpg`,
    source: 'Crafto'
  },
  {
    id: 'modern-business',
    category: 'Professional Services',
    name: 'Modern Business',
    description: 'Marketing, Innovation, Startup',
    demoUrl: `${CRAFTO_BASE}/demo-modern-business.html`,
    imageUrl: `${CRAFTO_BASE}/images/demo-modern-business.jpg`,
    source: 'Crafto'
  },
  {
    id: 'real-estate-crafto',
    category: 'Professional Services',
    name: 'Real Estate',
    description: 'Broker, Property, Directory',
    demoUrl: `${CRAFTO_BASE}/demo-real-estate.html`,
    imageUrl: `${CRAFTO_BASE}/images/demo-real-estate.jpg`,
    source: 'Crafto'
  },
  {
    id: 'canvas-classic',
    category: 'Professional Services',
    name: 'Classic Corporate',
    description: 'Traditional corporate website',
    demoUrl: `${CANVAS_BASE}/index-classic.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/classic.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-construction',
    category: 'Professional Services',
    name: 'Construction',
    description: 'Construction, Building, Contractors',
    demoUrl: `${CANVAS_BASE}/demo-construction.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/construction.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-real-estate',
    category: 'Professional Services',
    name: 'Real Estate Pro',
    description: 'Property listings, Real estate agency',
    demoUrl: `${CANVAS_BASE}/demo-real-estate.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/real-estate1.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-law-firm',
    category: 'Professional Services',
    name: 'Law Firm',
    description: 'Legal services, Attorney',
    demoUrl: `${CANVAS_BASE}/demo-law-firm.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/law-firm.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-finance',
    category: 'Professional Services',
    name: 'Finance',
    description: 'Financial services, Banking',
    demoUrl: `${CANVAS_BASE}/demo-finance.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/finance.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-insurance',
    category: 'Professional Services',
    name: 'Insurance',
    description: 'Insurance services, Business',
    demoUrl: `${CANVAS_BASE}/demo-insurance.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/insurance.jpg`,
    source: 'Canvas'
  },

  // ========== Technology & SaaS ==========
  {
    id: 'it-business',
    category: 'Technology & SaaS',
    name: 'IT Business',
    description: 'Business, Agency, IT solutions',
    demoUrl: `${CRAFTO_BASE}/demo-it-business.html`,
    imageUrl: `${CRAFTO_BASE}/images/demo-it-business.jpg`,
    source: 'Crafto'
  },
  {
    id: 'data-analysis',
    category: 'Technology & SaaS',
    name: 'Data Analysis',
    description: 'Analytics, Technology, Software',
    demoUrl: `${CRAFTO_BASE}/demo-data-analysis.html`,
    imageUrl: `${CRAFTO_BASE}/images/demo-data-analysis.jpg`,
    source: 'Crafto'
  },
  {
    id: 'elearning-crafto',
    category: 'Technology & SaaS',
    name: 'eLearning',
    description: 'Tutoring, Education, Online course',
    demoUrl: `${CRAFTO_BASE}/demo-elearning.html`,
    imageUrl: `${CRAFTO_BASE}/images/demo-elearning.jpg`,
    source: 'Crafto'
  },
  {
    id: 'seo-agency',
    category: 'Technology & SaaS',
    name: 'SEO Agency',
    description: 'Digital marketing, Advertising',
    demoUrl: `${CRAFTO_BASE}/demo-seo-agency.html`,
    imageUrl: `${CRAFTO_BASE}/images/demo-seo-agency.jpg`,
    source: 'Crafto'
  },
  {
    id: 'canvas-seo',
    category: 'Technology & SaaS',
    name: 'SEO',
    description: 'SEO services, Digital marketing',
    demoUrl: `${CANVAS_BASE}/demo-seo.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/seo.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-saas',
    category: 'Technology & SaaS',
    name: 'SaaS Landing',
    description: 'Software as a Service, Clean design',
    demoUrl: `${CANVAS_BASE}/demo-landing.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/landing.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-saas-2',
    category: 'Technology & SaaS',
    name: 'SaaS 2',
    description: 'Modern SaaS landing page',
    demoUrl: `${CANVAS_BASE}/demo-saas-2.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/saas-2.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-saas-3',
    category: 'Technology & SaaS',
    name: 'SaaS',
    description: 'Clean, Business SaaS',
    demoUrl: `${CANVAS_BASE}/demo-saas.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/saas.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-app-landing',
    category: 'Technology & SaaS',
    name: 'App Landing',
    description: 'Mobile app, Landing page',
    demoUrl: `${CANVAS_BASE}/demo-app-landing.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/app-landing.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-hosting',
    category: 'Technology & SaaS',
    name: 'Hosting',
    description: 'Web hosting, Cloud services',
    demoUrl: `${CANVAS_BASE}/demo-hosting.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/hosting.jpg`,
    source: 'Canvas'
  },

  // ========== Retail & Ecommerce ==========
  {
    id: 'fashion-store',
    category: 'Retail & Ecommerce',
    name: 'Fashion Store',
    description: 'Shop, eCommerce, Clothing',
    demoUrl: `${CRAFTO_BASE}/demo-fashion-store.html`,
    imageUrl: `${CRAFTO_BASE}/images/demo-fashion-store.jpg`,
    source: 'Crafto'
  },
  {
    id: 'canvas-ebook',
    category: 'Retail & Ecommerce',
    name: 'eBooks',
    description: 'Digital products, Online store',
    demoUrl: `${CANVAS_BASE}/demo-ebook.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/ebook.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-shop',
    category: 'Retail & Ecommerce',
    name: 'Shop',
    description: 'General eCommerce store',
    demoUrl: `${CANVAS_BASE}/demo-shop.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/shop.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-shop-2',
    category: 'Retail & Ecommerce',
    name: 'Shop 2',
    description: 'Creative eCommerce design',
    demoUrl: `${CANVAS_BASE}/demo-shop-2.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/shop-2.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-ecommerce',
    category: 'Retail & Ecommerce',
    name: 'eCommerce',
    description: 'Full shop with listings',
    demoUrl: `${CANVAS_BASE}/demo-ecommerce.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/ecommerce.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-store',
    category: 'Retail & Ecommerce',
    name: 'Store',
    description: 'Clean eCommerce store',
    demoUrl: `${CANVAS_BASE}/demo-store.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/store.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-wine',
    category: 'Retail & Ecommerce',
    name: 'Wine Shop',
    description: 'Wine, Beverages, eCommerce',
    demoUrl: `${CANVAS_BASE}/demo-wine.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/wine.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-supplements',
    category: 'Retail & Ecommerce',
    name: 'Supplements',
    description: 'Health products, eCommerce',
    demoUrl: `${CANVAS_BASE}/demo-supplements.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/supplements.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-drone',
    category: 'Retail & Ecommerce',
    name: 'Drone Store',
    description: 'Tech products, eCommerce',
    demoUrl: `${CANVAS_BASE}/demo-drone.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/drone.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-skincare',
    category: 'Retail & Ecommerce',
    name: 'Skincare',
    description: 'Beauty products, eCommerce',
    demoUrl: `${CANVAS_BASE}/demo-skincare.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/skincare.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-jewellery',
    category: 'Retail & Ecommerce',
    name: 'Jewellery Boutique',
    description: 'Luxury jewelry, Clean design',
    demoUrl: `${CANVAS_BASE}/demo-jewellery-boutique.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/jewellery.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-headphones',
    category: 'Retail & Ecommerce',
    name: 'Headphones',
    description: 'Electronics, Product showcase',
    demoUrl: `${CANVAS_BASE}/demo-headphones.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/headphones.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-furniture',
    category: 'Retail & Ecommerce',
    name: 'Furniture',
    description: 'Furniture store, Home decor',
    demoUrl: `${CANVAS_BASE}/demo-furniture.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/furniture.jpg`,
    source: 'Canvas'
  },

  // ========== Creative & Agency ==========
  {
    id: 'branding-agency',
    category: 'Creative & Agency',
    name: 'Branding Agency',
    description: 'Design studio, Identity, Agency',
    demoUrl: `${CRAFTO_BASE}/demo-branding-agency.html`,
    imageUrl: `${CRAFTO_BASE}/images/demo-branding-agency.jpg`,
    source: 'Crafto'
  },
  {
    id: 'digital-agency',
    category: 'Creative & Agency',
    name: 'Digital Agency',
    description: 'Marketing agency, Media, SEO agency',
    demoUrl: `${CRAFTO_BASE}/demo-digital-agency.html`,
    imageUrl: `${CRAFTO_BASE}/images/demo-digital-agency.jpg`,
    source: 'Crafto'
  },
  {
    id: 'web-agency',
    category: 'Creative & Agency',
    name: 'Web Agency',
    description: 'Marketing, Branding, Development',
    demoUrl: `${CRAFTO_BASE}/demo-web-agency.html`,
    imageUrl: `${CRAFTO_BASE}/images/demo-web-agency.jpg`,
    source: 'Crafto'
  },
  {
    id: 'design-agency',
    category: 'Creative & Agency',
    name: 'Design Agency',
    description: 'Creative studio, Web, Portfolio',
    demoUrl: `${CRAFTO_BASE}/demo-design-agency.html`,
    imageUrl: `${CRAFTO_BASE}/images/demo-design-agency.jpg`,
    source: 'Crafto'
  },
  {
    id: 'scattered-portfolio',
    category: 'Creative & Agency',
    name: 'Scattered Portfolio',
    description: 'Photography, Personal, Freelancers',
    demoUrl: `${CRAFTO_BASE}/demo-scattered-portfolio.html`,
    imageUrl: `${CRAFTO_BASE}/images/demo-scattered-portfolio.jpg`,
    source: 'Crafto'
  },
  {
    id: 'interactive-portfolio',
    category: 'Creative & Agency',
    name: 'Interactive Portfolio',
    description: 'Modern portfolio, CV, Resume',
    demoUrl: `${CRAFTO_BASE}/demo-interactive-portfolio.html`,
    imageUrl: `${CRAFTO_BASE}/images/demo-interactive-portfolio.jpg`,
    source: 'Crafto'
  },
  {
    id: 'minimal-portfolio',
    category: 'Creative & Agency',
    name: 'Minimal Portfolio',
    description: 'Creative professional, Digital agencies',
    demoUrl: `${CRAFTO_BASE}/demo-minimal-portfolio.html`,
    imageUrl: `${CRAFTO_BASE}/images/demo-minimal-portfolio.jpg`,
    source: 'Crafto'
  },
  {
    id: 'canvas-personal',
    category: 'Creative & Agency',
    name: 'Personal',
    description: 'Personal website, Creative portfolio',
    demoUrl: `${CANVAS_BASE}/demo-personal.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/personal.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-gaming',
    category: 'Creative & Agency',
    name: 'Gaming',
    description: 'Gaming, Entertainment, Media',
    demoUrl: `${CANVAS_BASE}/demo-gaming.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/gaming.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-portfolio',
    category: 'Creative & Agency',
    name: 'Portfolio',
    description: 'Creative portfolio, Media',
    demoUrl: `${CANVAS_BASE}/demo-portfolio.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/portfolio.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-project',
    category: 'Creative & Agency',
    name: 'Project',
    description: 'Portfolio, Project showcase',
    demoUrl: `${CANVAS_BASE}/demo-project.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/project.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-videographer',
    category: 'Creative & Agency',
    name: 'Videographer',
    description: 'Video production, Creative',
    demoUrl: `${CANVAS_BASE}/demo-videographer.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/videographer.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-photographer',
    category: 'Creative & Agency',
    name: 'Photographer',
    description: 'Photography, Resume portfolio',
    demoUrl: `${CANVAS_BASE}/demo-photographer.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/photographer.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-agency',
    category: 'Creative & Agency',
    name: 'Agency',
    description: 'Creative agency, Portfolio',
    demoUrl: `${CANVAS_BASE}/demo-agency.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/agency.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-media-agency',
    category: 'Creative & Agency',
    name: 'Media Agency',
    description: 'Media production, One-page',
    demoUrl: `${CANVAS_BASE}/demo-media-agency.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/media-agency.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-writer',
    category: 'Creative & Agency',
    name: 'Writer',
    description: 'Author, Creative portfolio',
    demoUrl: `${CANVAS_BASE}/demo-writer.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/writer.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-interior-design',
    category: 'Creative & Agency',
    name: 'Interior Design',
    description: 'Design services, Clean business',
    demoUrl: `${CANVAS_BASE}/demo-interior-design.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/interior-design.jpg`,
    source: 'Canvas'
  },

  // ========== Food & Hospitality ==========
  {
    id: 'restaurant-crafto',
    category: 'Food & Hospitality',
    name: 'Restaurant',
    description: 'Food, Dining, Cafe, Meals',
    demoUrl: `${CRAFTO_BASE}/demo-restaurant.html`,
    imageUrl: `${CRAFTO_BASE}/images/demo-restaurant.jpg`,
    source: 'Crafto'
  },
  {
    id: 'hotel-resort',
    category: 'Food & Hospitality',
    name: 'Hotel & Resort',
    description: 'Holiday homes, Accommodation',
    demoUrl: `${CRAFTO_BASE}/demo-hotel-and-resort.html`,
    imageUrl: `${CRAFTO_BASE}/images/demo-hotel-and-resort.jpg`,
    source: 'Crafto'
  },
  {
    id: 'canvas-travel',
    category: 'Food & Hospitality',
    name: 'Travel',
    description: 'Travel agency, Tours, Magazine',
    demoUrl: `${CANVAS_BASE}/demo-travel.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/travel.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-restaurant',
    category: 'Food & Hospitality',
    name: 'Restaurant Modern',
    description: 'Creative restaurant, Food',
    demoUrl: `${CANVAS_BASE}/demo-restaurant.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/restaurant.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-cafe',
    category: 'Food & Hospitality',
    name: 'Cafe',
    description: 'Coffee shop, Food landing',
    demoUrl: `${CANVAS_BASE}/demo-cafe.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/cafe.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-burger',
    category: 'Food & Hospitality',
    name: 'Burger',
    description: 'Fast food, One-page',
    demoUrl: `${CANVAS_BASE}/demo-burger.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/burger.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-hostel',
    category: 'Food & Hospitality',
    name: 'Hostel',
    description: 'Budget accommodation, Travel',
    demoUrl: `${CANVAS_BASE}/demo-hostel.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/hostel.jpg`,
    source: 'Canvas'
  },

  // ========== Healthcare & Wellness ==========
  {
    id: 'medical-crafto',
    category: 'Healthcare & Wellness',
    name: 'Medical',
    description: 'Clinic, Healthcare, Wellness',
    demoUrl: `${CRAFTO_BASE}/demo-medical.html`,
    imageUrl: `${CRAFTO_BASE}/images/demo-medical.jpg`,
    source: 'Crafto'
  },
  {
    id: 'canvas-doctors',
    category: 'Healthcare & Wellness',
    name: 'Doctors',
    description: 'Medical practice, Health landing',
    demoUrl: `${CANVAS_BASE}/demo-doctors.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/doctors.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-medical',
    category: 'Healthcare & Wellness',
    name: 'Medical Center',
    description: 'Hospital, Health services',
    demoUrl: `${CANVAS_BASE}/demo-medical.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/medical.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-beauty',
    category: 'Healthcare & Wellness',
    name: 'Beauty',
    description: 'Beauty salon, One-page health',
    demoUrl: `${CANVAS_BASE}/demo-beauty.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/beauty.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-gym',
    category: 'Healthcare & Wellness',
    name: 'Gym',
    description: 'Fitness center, Health business',
    demoUrl: `${CANVAS_BASE}/demo-gym.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/gym.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-yoga',
    category: 'Healthcare & Wellness',
    name: 'Yoga',
    description: 'Yoga studio, Wellness, Health',
    demoUrl: `${CANVAS_BASE}/demo-yoga.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/yoga.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-therapy',
    category: 'Healthcare & Wellness',
    name: 'Therapy',
    description: 'Mental health, Wellness services',
    demoUrl: `${CANVAS_BASE}/demo-therapy.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/therapy.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-spa',
    category: 'Healthcare & Wellness',
    name: 'Spa',
    description: 'Spa services, Health, Clean',
    demoUrl: `${CANVAS_BASE}/demo-spa.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/spa.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-barber',
    category: 'Healthcare & Wellness',
    name: 'Barber',
    description: 'Barbershop, Beauty landing',
    demoUrl: `${CANVAS_BASE}/demo-barber.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/barber.jpg`,
    source: 'Canvas'
  },
  {
    id: 'canvas-beauty-kit',
    category: 'Healthcare & Wellness',
    name: 'Beauty Kit',
    description: 'Beauty products, Health landing',
    demoUrl: `${CANVAS_BASE}/demo-beauty-kit.html`,
    imageUrl: `${CANVAS_BASE}/images/intro/niche/new/beauty-kit.jpg`,
    source: 'Canvas'
  }
]

// Get templates by category
export const getTemplatesByCategory = (category) => {
  return TEMPLATES.filter(template => template.category === category)
}

// Get template by ID
export const getTemplateById = (id) => {
  return TEMPLATES.find(template => template.id === id)
}

// Get all categories with template counts
export const getCategoriesWithCounts = () => {
  return TEMPLATE_CATEGORIES.map(category => ({
    name: category,
    count: TEMPLATES.filter(t => t.category === category).length
  }))
}

// Total templates count
export const getTotalTemplatesCount = () => TEMPLATES.length
